import * as Sentry from '@sentry/angular';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.name !== 'local') {
    Sentry.init({
        dsn: 'https://0b7d997e2a1b5939206c72db6bb3c2df@o4506751146590208.ingest.us.sentry.io/4509969853644800',
        environment: environment.name,
    });
}
platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
